<template>
    <div >


<table class="table">
  <thead class="thead-light">
    <tr>
      <th scope="col">Kitchen</th>
      <th scope="col">Edit</th>
      <th scope="col">Add dishes</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="kitchen in store.kitchens" :key="kitchen.id">
      <th scope="row"><li>{{ kitchen.name }}</li></th>
      <td>
        <svg @click="editKitchen(kitchen.id)" class="edit" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
            <path
                d="M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z" />
        </svg>
      </td>
      <td @click="goTo(kitchen.id)">add Dishes</td>
    </tr>
    
  </tbody>
</table>
        
        

    </div>
</template>

<script setup>
import { onMounted } from "vue";

import api from "@/services/api";

import { useKitchenStore } from "@/stores/kitchen";
import { useRouter } from "vue-router";


const router = useRouter();

const store = useKitchenStore();

function goTo(id){
    router.push('/user/admin/kitchen/'+ id );
}

async function getKitchens(){

    const results = await api.get('/user/admin/kitchens');

     store.setKitchens(results.data);
}

function editKitchen(id){
    store.toggleKitchenCreateModal();

    const kitchen = store.kitchens.find(el => {
        if(el.id == id ){
            return true;
        }
    });
    
    store.changeKitchen(kitchen);
    
    const placeIds = kitchen.places.map(el => el.id );

    store.changeSelectedPlaces(placeIds);
}

onMounted(()=>{
    getKitchens();
})


</script>

<style scoped>
 .edit {
    height: 15px;
  }
 
</style>